import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import {
    Box,
    Button,
    IconButton,
    FormLabel,
    Typography,
    Grid2,
    Card,
} from '@mui/material';
import { getAssets } from '../../actions/mediaAction';
import ExistingMediaUploadPopup from './ExistingMediaUploadPopup';
import DeleteIcon from '../../assets/images/icons/delete_icon.svg';
import AddMedia from '../../pages/media/AddMedia';

const MediaUpload = ({ workspaceId, name, onChange, value = [] }) => {
    const [files, setFiles] = useState(Array.isArray(value) ? value : []);
    const [existingMediaPopup, setExistingMediaPopup] = useState(false);
    const [newMediaPopup, setNewMediaPopup] = useState(false);
    const dispatch = useDispatch();

    useEffect(() => {
        if (value) {
            const formattedFiles = Array.isArray(value) ? value : [value];
            const validFiles = formattedFiles.filter(file => file && file._id && file.url);
            setFiles(validFiles);
        }
    }, [value]);


    const handleAddExistingMedia = (selectedAssets) => {
        const formattedFiles = selectedAssets.map(asset => ({
            _id: asset._id,
            title: asset.title,
            description: asset.description,
            url: asset.url,

        }))

        const updatedFiles = [...files, ...formattedFiles];
        setFiles(updatedFiles);
        onChange(updatedFiles);
    };

    const handleAddNewMedia = async (response) => {
        try {
            const assets = await dispatch(getAssets(workspaceId));
            const newAsset = assets.find(asset => asset._id === response.entryId);

            if (newAsset) {
                const formattedFile = {
                    _id: newAsset._id,
                    title: newAsset.title || 'Untitled',
                    description: newAsset.description || '',
                    url: newAsset.url,
                    fileName: newAsset.fileName
                };

                const updatedFiles = [...files, formattedFile];
                setFiles(updatedFiles);
                onChange(updatedFiles);
            }

            setNewMediaPopup(false);
        } catch (error) {
            console.error('Error fetching asset details:', error);
        }
    };

    const handleRemoveFile = (index) => {
        const newFiles = files.filter((_, i) => i !== index);
        setFiles(newFiles);

        // If no files are left, pass an empty string to onChange
        if (newFiles.length === 0) {
            onChange("");
        } else {
            onChange(newFiles);
        }
    };


    return (
        <Box sx={{ width: '100%' }}>
            <FormLabel component="legend" sx={{ color: 'black' }}>{name}</FormLabel>
            <Box
                sx={{
                    border: '2px dashed #ccc',
                    borderRadius: 2,
                    p: 3,
                    mb: 2,
                    mt: 1,
                    textAlign: 'center',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 2
                }}
            >
                <Button
                    variant="outlined"
                    onClick={() => setExistingMediaPopup(true)}
                    sx={{
                        borderColor: 'primary.main',
                        color: 'primary.main',
                        '&:hover': {
                            borderColor: 'primary.dark',
                            backgroundColor: 'primary.light',
                            color: 'white'
                        }
                    }}
                >
                    Add Existing Media
                </Button>

                <Button
                    variant="outlined"
                    onClick={() => setNewMediaPopup(true)}
                    sx={{
                        borderColor: 'primary.main',
                        color: 'primary.main',
                        '&:hover': {
                            borderColor: 'primary.dark',
                            backgroundColor: 'primary.light',
                            color: 'white'
                        }
                    }}
                >
                    Add New Media
                </Button>
            </Box>

            {files.length > 0 && (
                <Grid2 container spacing={2}>
                    {files.map((file, index) => (
                        <Grid2 key={index}>
                            <Card sx={{ position: 'relative' }}>
                                <Box sx={{
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                }}>
                                    <img
                                        src={file.url}
                                        alt={file.title}
                                        style={{
                                            width: '200px',
                                            height: '100px',
                                            objectFit: 'cover'
                                        }}
                                    />
                                </Box>
                                <IconButton
                                    sx={{
                                        position: 'absolute',
                                        top: 8,
                                        right: 8,
                                        color: '#960101',
                                        '&:hover': { bgcolor: 'grey.100' }
                                    }}
                                    onClick={() => handleRemoveFile(index)}
                                >
                                    <img
                                        src={DeleteIcon}
                                        alt="delete icon"
                                        style={{ width: '24px', height: '24px' }}
                                    />
                                </IconButton>
                                <Typography variant='subtitle1'>{file.title || file.fileName}</Typography>
                            </Card>
                        </Grid2>
                    ))}
                </Grid2>
            )}

            <AddMedia
                isOpen={newMediaPopup}
                onClose={() => setNewMediaPopup(false)}
                onSubmitSuccess={handleAddNewMedia}
                editMode={false}
            />

            <ExistingMediaUploadPopup
                open={existingMediaPopup}
                onClose={() => setExistingMediaPopup(false)}
                onConfirm={handleAddExistingMedia}
                workspaceId={workspaceId}
            />
        </Box>
    );
};

export default MediaUpload;